import { render, staticRenderFns } from "./TheTableDeliveryOrders.vue?vue&type=template&id=7bc6fc00&scoped=true&"
import script from "./TheTableDeliveryOrders.vue?vue&type=script&lang=ts&"
export * from "./TheTableDeliveryOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6fc00",
  null
  
)

export default component.exports